import { ConnectStore } from 'views/ConnectStore';

export default [
  {
    path: '/connect-store',
    name: 'Connect Store',
    component: ConnectStore
  }
];
